import {createAction} from 'redux-act'

export const showSuccessFlashMessage = createAction('Show success flash message')
export const showErrorFlashMessage = createAction('Show error flash message')
export const hideFlashMessage = createAction('Hide flash message')
